var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activity.system_activity_stage_id > 1)?_c('a',{staticClass:"kt-link text-hover-primary",attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('p',{staticClass:"mb-0 text-center"},[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }